import { Card, Chip, Grid, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import styles from "../../../../styles/global-styles";
import {
  customDate,
  getRemainingDaysGuarantee,
} from "../../../../_utils/utils";

const usetSyles = makeStyles((theme) => ({
  root: { width: "106%" },
  card: {
    minWidth: 450,
    width: 920,
    marginTop: theme.spacing(4),
    padding: theme.spacing(5),
    height: "auto",
    textAlign: "center",
    borderRadius: 13,
    background: "white",
  },
  typography: {
    fontWeight: 400,
    marginBottom: 8,
    color: "#1C2668",
    opacity: 0.5,
  },
  nameSite: {
    color: "#1C2668",
    fontWeight: 600,
    position: "absolute",
    top: "180px",
    marginLeft: 40,
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      width: "8vw !Important",
      maxWidth: 150,
      border: "0.2px solid #f2f2f2",
    },
  },
  chip: styles.chip,
}));

const ProductResume = ({ productDetail, sellInfo, isAccesory }) => {
  const classes = usetSyles();
  // console.log("isAccesory", isAccesory);
  // console.log("sellInfo", sellInfo);
  // console.log("productDetail", productDetail);

  return (
    <Card className={classes.card}>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        spacing={4}
      >
        {isAccesory && (
          <Grid item xs={6} md={4} lg={3}>
            <Typography
              color="primary"
              className={classes.typography}
              variant="subtitle1"
            >
              Subcategoría
            </Typography>
            <Typography> {isAccesory.name}</Typography>
          </Grid>
        )}

        <Grid item xs={6} md={4} lg={3}>
          <Typography
            color="primary"
            className={classes.typography}
            variant="subtitle1"
          >
            Marca
          </Typography>
          <Typography> {productDetail.brand}</Typography>
        </Grid>

        <Grid item xs={6} md={4} lg={3}>
          <Typography
            color="primary"
            className={classes.typography}
            variant="subtitle1"
          >
            Modelo
          </Typography>
          <Typography> {productDetail.model}</Typography>
        </Grid>
        <Grid item xs={6} md={4} lg={3}>
          <Typography
            color="primary"
            className={classes.typography}
            variant="subtitle1"
          >
            IMEI
          </Typography>
          <Typography> {productDetail.imeiCode}</Typography>
        </Grid>
        {!isAccesory && (
          <Grid item xs={6} md={4} lg={3}>
            <Typography
              color="primary"
              className={classes.typography}
              variant="subtitle1"
            >
              Color
            </Typography>
            <Chip label={productDetail.color} className={classes.chip} />
          </Grid>
        )}
        <Grid item xs={6} md={4} lg={3}>
          <Typography
            color="primary"
            className={classes.typography}
            variant="subtitle1"
          >
            Vendido por
          </Typography>
          <Typography> {sellInfo.user?.name || ""} </Typography>
        </Grid>
        <Grid item xs={6} md={4} lg={3}>
          <Typography
            color="primary"
            className={classes.typography}
            variant="subtitle1"
          >
            Fecha de venta
          </Typography>
          <Typography> {customDate(sellInfo.createdAt)} </Typography>
        </Grid>
        {!isAccesory && (
          <Grid item xs={6} md={4} lg={3}>
            <Typography
              color="primary"
              className={classes.typography}
              variant="subtitle1"
            >
              Capacidad
            </Typography>
            <Typography>Gigas {productDetail.capacity} megas</Typography>
          </Grid>
        )}
        <Grid item xs={6} md={4} lg={3}>
          <Typography
            color="primary"
            className={classes.typography}
            variant="subtitle1"
          >
            Proveedor
          </Typography>
          <Typography>{productDetail.provider.alias}</Typography>
        </Grid>
        <Grid item xs={6} md={4} lg={3}>
          <Typography
            color="primary"
            className={classes.typography}
            variant="subtitle1"
          >
            Garantía
          </Typography>
          <Typography>{productDetail.provider.timeGuarantee} días</Typography>
        </Grid>
        <Grid item xs={6} md={4} lg={3}>
          <Typography
            color="primary"
            className={classes.typography}
            variant="subtitle1"
          >
            Dias restantes
          </Typography>
          <Typography style={{ fontWeight: 900 }}>
            {getRemainingDaysGuarantee(sellInfo)} días
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
};

export default ProductResume;
